import React, { createContext, useReducer, useContext } from "react";
import ReportesService from "../services/ReportesService";
import ReportesReducer from "../reducers/ReportesReducer";
import {
  SET_GENERANDO_PDF,
  REPORTES_RECEIVED,
  SET_REPORTE,
  CREATE_REPORTE,
  SET_PROPERTY_REPORTE,
} from "../types/reports";
import { ModalContext } from "./ModalContext";
import { HIDE_SPINNER, SHOW_SPINNER } from "../types";
import { useNavigate } from "react-router-dom";

const initialState = {
  reportes: null,
  reporte: null,
  generandoPDF: false,
};

export const ReportesContext = createContext(initialState);

export const ReportesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ReportesReducer, initialState);

  const { alert, success, clearModal } = useContext(ModalContext);

  const navigate = useNavigate();

  const getReportes = (idProyecto) => {
    ReportesService.getReportes(idProyecto)
      .then((response) => {
        const { reportes } = response.data;
        dispatch({ type: REPORTES_RECEIVED, payload: reportes });
      })
      .catch((error) => {
        alert(error);
      });
  };

  const getSingleReporte = (idProyecto, idReporte) => {
    ReportesService.getSingleReporte(idProyecto, idReporte)
      .then((response) => {
        const { reporte } = response.data;
        dispatch({ type: SET_REPORTE, payload: reporte });
      })
      .catch((error) => {
        alert(error);
      });
  };

  const setReporte = (reporte) => {
    dispatch({ type: SET_REPORTE, payload: reporte });
  };

  const createReporte = () => {
    dispatch({ type: CREATE_REPORTE });
  };

  const setPropertyReporte = (key, value) => {
    dispatch({ type: SET_PROPERTY_REPORTE, payload: { key, value } });
  };

  const sendReporte = (idProyecto, data) => {
    dispatch({ type: SHOW_SPINNER });
    ReportesService.sendReporte(idProyecto, data)
      .then(() => {
        success("Reporte enviado.");
        dispatch({ type: HIDE_SPINNER });
      })
      .catch((error) => {
        dispatch({ type: HIDE_SPINNER });
        alert(error);
      });
  }

  const saveReporte = (reporte, callback) => {
    dispatch({ type: SHOW_SPINNER });
    const postCall = isNaN(parseInt(reporte.idReporte));
    let service = ReportesService.putReporte;
    if (postCall) {
      service = ReportesService.postReporte;
    }
    service(reporte)
      .then((res) => {
        success("Reporte guardado.");
        dispatch({ type: HIDE_SPINNER });
        clearModal();
        if (postCall) {
          const { reporte } = res.data;
          const { idProyecto, idReporte } = reporte;
          navigate(`/obra/${idProyecto}/reportes/${idReporte}`);
        }
        if (typeof callback === "function") {
          callback();
        }
      })
      .catch((error) => {
        dispatch({ type: HIDE_SPINNER });
        alert(error);
      });
  };

  const deleteReporte = (idProyecto, idReporte, callback) => {
    dispatch({ type: SHOW_SPINNER });
    ReportesService.deleteReporte(idProyecto, idReporte)
      .then(() => {
        success("Reporte deleted.");
        dispatch({ type: HIDE_SPINNER });
        clearModal();
        if (typeof callback === "function") {
          callback();
        }
      })
      .catch((error) => {
        dispatch({ type: HIDE_SPINNER });
        alert(error);
      });
  };

  // URL of the report's PDF; `regenerar` prints it again on the server.
  // Opens the report's PDF (the server generates it again when the saved
  // file is missing); prints from the browser when there is no PDF.
  const abrirReportePDF = (idProyecto, reporte) => {
    if (reporte.Adjunto === null) return window.print();
    // Open the tab now (inside the click) so the browser doesn't block it.
    const tab = window.open("", "_blank");
    dispatch({ type: SET_GENERANDO_PDF, payload: "imprimir" });
    ReportesService.getReportePDF(idProyecto, reporte.idReporte)
      .then((res) => {
        if (tab) tab.location.href = res.data.url;
        else window.open(res.data.url, "_blank");
      })
      .catch(() => {
        if (tab) tab.close();
        window.print();
      })
      .finally(() => dispatch({ type: SET_GENERANDO_PDF, payload: false }));
  };

  // Prints the report's PDF again on the server (its data stays as saved).
  const regenerarReportePDF = (idProyecto, idReporte) => {
    dispatch({ type: SET_GENERANDO_PDF, payload: "regenerar" });
    ReportesService.getReportePDF(idProyecto, idReporte, true)
      .then(() => {
        success("PDF del reporte regenerado.");
        getSingleReporte(idProyecto, idReporte);
      })
      .catch(alert)
      .finally(() => dispatch({ type: SET_GENERANDO_PDF, payload: false }));
  };

  return (
    <ReportesContext.Provider
      value={{
        abrirReportePDF,
        regenerarReportePDF,
        ...state,
        setReporte,
        getReportes,
        saveReporte,
        sendReporte,
        deleteReporte,
        createReporte,
        getSingleReporte,
        setPropertyReporte,
      }}
    >
      {children}
    </ReportesContext.Provider>
  );
};
